import { createApi } from "@reduxjs/toolkit/query/react";

import { IFarmLandDto } from "../../pages/fields/shared/dtos/farm-land.dto";
import { baseQuery } from "../../shared/api/base-query";
import { pagedQueryFn } from "../../shared/api/paged-query-fn";
import { buildFilterCondition } from "../../shared/utils/build-filter-condition";
import { buildFilterExpression } from "../../shared/utils/build-filter-expression";

export type FetchFarmLandsRequest = {
  farmId: string;
  seasonId: string;
};

const buildFarmLandsRequest = ({ farmId, seasonId }: FetchFarmLandsRequest) => ({
  url: "FarmLandsV2",
  params: {
    filter: buildFilterExpression(
      buildFilterCondition("farmId", "==", farmId),
      buildFilterCondition("seasonId", "==", seasonId)
    ),
    includeDeleted: true,
  },
  method: "GET",
});

const sortByName = (dtos: IFarmLandDto[]): IFarmLandDto[] => {
  dtos.sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0));
  return dtos;
};

export const currentFarmLandsApiSlice = createApi({
  reducerPath: "api-farm-lands-related",
  baseQuery,
  endpoints: (builder) => ({
    fetchFarmLandsWithDeleted: builder.query<IFarmLandDto[], FetchFarmLandsRequest>({
      queryFn: pagedQueryFn<IFarmLandDto, IFarmLandDto[], FetchFarmLandsRequest>(
        buildFarmLandsRequest,
        sortByName
      ),
    }),
  }),
});
